// Copyright (c) 2017 Deere & Company

import DealerInvoiceSearchBoxContainer from './dealer-invoice-search-box-container';
import actionCreators from '../../action-creators';
import {connect} from 'react-redux';

const getStateToBindToContainerProps = state => ({
    searchByDropDown: state.claims.searchDropDown,
    searchQueryString: state.claims.searchQueryString
});

const mapBoundActionCreatorsToActionsProp = (stateProps, dispatchProps, parentProps) => {

    const {routeParams} = parentProps;

    return {
        ...stateProps,
        actions: {
            ...dispatchProps
        },
        routeParams
    };

};

export default connect(getStateToBindToContainerProps, actionCreators, mapBoundActionCreatorsToActionsProp)(DealerInvoiceSearchBoxContainer);



// WEBPACK FOOTER //
// ./src/claim/dealer-invoices/components/dealer-invoice-search-box/index.js